import { render, staticRenderFns } from "./SpinnerWheelContentTab.vue?vue&type=template&id=78dde567&scoped=true&"
import script from "./SpinnerWheelContentTab.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelContentTab.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelContentTab.vue?vue&type=style&index=0&id=78dde567&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dde567",
  null
  
)

export default component.exports